import {
  preFormatForm,
  SaveCard,
  ticketViewConstraints,
  validateForm,
  getTranslatedText,
  EventEmitter,
  getParsedCrudData
} from '@nile/components';
import { ViewContainer } from '@nile/mangifera/src/Containers/PageContainers';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { Page } from '@superops/ui-design-system';
import { entityShareType } from '@nile/mangifera/src/Constants/Tickets';
import { cloneDeep } from 'lodash';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

class ViewSheet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewCondition: props.context?.activeTab?.state?.viewCondition
        ? props.context?.activeTab?.state?.viewCondition
        : props.view?.viewCondition
        ? {
            ruleCondition: props.view.viewCondition
          }
        : {
            description: '',
            active: true,
            ruleCondition: { joinOperator: 'AND', operands: Array(0) }
          },
      view: props.context?.activeTab?.state?.view ||
        props.view || {
          name: '',
          shared: false
        },
      entityShare:
        props.context?.activeTab?.state?.entityShare || props.entityShare || {},
      personalization:
        props.context?.activeTab?.state?.personalization ||
        props.personalization ||
        '',
      errors: {},
      submitActionLoading: false
    };
  }

  componentDidMount() {
    EventEmitter.subscribe('tabChange', this.updateTabState);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe('tabChange');
  }

  updateTabState = (eventData) => {
    this.props.context.updateTabState(
      {
        view: this.state.view,
        personalization: this.state.personalization,
        viewCondition: this.state.viewCondition
      },
      eventData
    );
  };

  updateFields = (rule, key) => {
    this.setState({
      viewCondition: {
        ...this.state.viewCondition,
        [key]: rule
      }
    });
  };
  updateProperty = (key, value) => {
    this.setState({
      [key]: value
    });
  };
  updateContext = (key, value) => {
    this.setState({
      view: {
        ...this.state.view,
        [key]: value
      }
    });
  };
  updateShareView = (value) => {
    this.setState({
      entityShare: value
    });
  };

  getUpdateEntityShare = () => {
    const { entityShare: stateEntityShare } = this.state;
    const { entityShare: propsEntityShare } = this.props;
    const { shared } = this.state.view;

    if (!shared) {
      return {
        userShareType: null,
        groupShareType: null
      };
    }
    const {
      groupShareType: actualGroupShareType,
      userShareType: actualUserShareType,
      users: actualUsers,
      groups: actualGroups
    } = propsEntityShare;
    const {
      groupShareType: updatedGroupShareType,
      userShareType: updatedUserShareType
    } = stateEntityShare;

    const updatedUsers = stateEntityShare.users || stateEntityShare.userIds;
    const updatedGroups = stateEntityShare.groups || stateEntityShare.groupIds;

    //case 1: groupsharetype is specific from api and updated groupsharetype is SPECIFIC
    if (
      actualGroupShareType === entityShareType.SPECIFIC &&
      updatedGroupShareType === entityShareType.SPECIFIC
    ) {
      const { addedItems, deletedItems } = getParsedCrudData(
        actualGroups,
        updatedGroups,
        'groupId'
      );
      return {
        groupShareType: entityShareType.SPECIFIC,
        addGroupIds: addedItems,
        deleteGroupIds: deletedItems.map((item) => ({
          groupId: item.groupId
        }))
      };
    }

    //case 2: usersharetype is specific from api and updated usersharetype is SPECIFIC
    if (
      actualUserShareType === entityShareType.SPECIFIC &&
      updatedUserShareType === entityShareType.SPECIFIC
    ) {
      const { addedItems, deletedItems } = getParsedCrudData(
        actualUsers,
        updatedUsers,
        'userId'
      );
      return {
        userShareType: entityShareType.SPECIFIC,
        addUserIds: addedItems,
        deleteUserIds: deletedItems.map((item) => ({
          userId: item.userId,
          email: item.email
        }))
      };
    }

    //case 3: groupsharetype or usersharetype is specific or null from api and updated usersharetype is ALL
    if (
      (!actualGroupShareType ||
        actualGroupShareType === entityShareType.SPECIFIC ||
        actualUserShareType === entityShareType.SPECIFIC) &&
      updatedUserShareType === entityShareType.ALL
    ) {
      return {
        userShareType: entityShareType.ALL
      };
    }

    //case 4: groupsharetype is specific from api and updated usersharetype is SPECIFIC
    if (
      actualGroupShareType === entityShareType.SPECIFIC &&
      updatedUserShareType === entityShareType.SPECIFIC
    ) {
      return {
        userShareType: entityShareType.SPECIFIC,
        addUserIds: updatedUsers
      };
    }

    //case 5: usersharetype is specific from api and updated groupsharetype is SPECIFIC
    if (
      actualUserShareType === entityShareType.SPECIFIC &&
      updatedGroupShareType === entityShareType.SPECIFIC
    ) {
      return {
        groupShareType: entityShareType.SPECIFIC,
        addGroupIds: updatedGroups
      };
    }

    //case 6: usersharetype is all from api and updated usersharetype or groupsharetype is SPECIFIC
    if (
      actualUserShareType === entityShareType.ALL &&
      (updatedUserShareType === entityShareType.SPECIFIC ||
        updatedGroupShareType === entityShareType.SPECIFIC)
    ) {
      if (updatedUserShareType === entityShareType.SPECIFIC) {
        return {
          userShareType: entityShareType.SPECIFIC,
          addUserIds: updatedUsers
        };
      }
      if (updatedGroupShareType === entityShareType.SPECIFIC) {
        return {
          groupShareType: entityShareType.SPECIFIC,
          addGroupIds: updatedGroups
        };
      }
    }
    return {};
  };

  createOrUpdateViewType = () => {
    const { actions, view, defaultSelectedColumns, appContext } = this.props;
    const { personalization: statePersonalization } = this.state;
    const { ruleCondition } = this.state.viewCondition;
    const currentUser = appContext.user;
    const personalizationUser = {
      firstName: currentUser.firstName,
      userId: currentUser.userId,
      email: currentUser.email,
      lastName: currentUser.lastName
    };
    const personalization = statePersonalization
      ? {
          ...statePersonalization,
          user: statePersonalization.user || personalizationUser
        }
      : null;
    const defaultPersonalization = personalization || {
      user: personalizationUser,
      category: 'TicketView',
      value: JSON.stringify(defaultSelectedColumns)
    };
    let dummyform = cloneDeep({
      ...this.state.view,
      // viewCondition: ruleCondition,
      personalization: defaultPersonalization
    });
    const { userShareType, groupShareType } = this.state.entityShare;
    if (this.state.view.shared && userShareType === entityShareType.SPECIFIC) {
      dummyform = {
        ...dummyform,
        technicians:
          this.state.entityShare.userIds || this.state.entityShare.users
      };
    }
    if (this.state.view.shared && groupShareType === entityShareType.SPECIFIC) {
      dummyform = {
        ...dummyform,
        technicians:
          this.state.entityShare.groupIds || this.state.entityShare.groups
      };
    }

    const isSpecificUser = [userShareType, groupShareType].includes(
      entityShareType.SPECIFIC
    );

    const entityShareConstraints = isSpecificUser
      ? {
          technicians: {
            presence: {
              allowEmpty: false,
              message: '^Select technician'
            }
          }
        }
      : {};

    const validationConstraints = {
      ...ticketViewConstraints,
      ...entityShareConstraints
    };

    const _dummyForm = preFormatForm(dummyform);
    const validationResult = validateForm(
      { ..._dummyForm, viewCondition: ruleCondition },
      validationConstraints
    );

    if (validationResult) {
      this.setState({ errors: validationResult });
      return;
    }
    this.setState({ errors: {} });

    if (actions.primaryAction) {
      let primaryActionInput = {};

      if (this.props.entityShareKey === 'addEntityShare') {
        primaryActionInput.variables = {
          ...this.state.view,
          viewCondition: ruleCondition
        };
        if (this.state.view.shared) {
          primaryActionInput.variables.addEntityShare = {
            ...this.state.entityShare
          };
        }
      } else if (this.props.entityShareKey === 'updateEntityShare') {
        primaryActionInput.variables = {
          id: this.props.view.id,
          customView: this.props.view.customView,
          shared: this.state.view.shared,
          name: this.state.view.name,
          viewCondition: ruleCondition
        };
        if (this.props.entityShare && this.state.view.shared) {
          primaryActionInput.variables.updateEntityShare = {
            id: this.props.entityShare.id,
            ...this.getUpdateEntityShare()
          };
        } else if (this.state.view.shared && !this.props.entityShare) {
          primaryActionInput.variables.addEntityShare = {
            ...this.state.entityShare
          };
        } else if (!this.state.view.shared && this.props.entityShare) {
          primaryActionInput.variables.deleteEntityShare = {
            id: this.props.entityShare.id
          };
        }
      }
      this.setState({ submitActionLoading: true });
      actions.primaryAction(primaryActionInput).then((res) => {
        let createdView = res.data?.addTicketView || res.data.updateTicketView;
        const currentUser = appContext.user;
        const defaultPersonalization = personalization || {
          user: {
            firstName: currentUser.firstName,
            userId: currentUser.userId,
            email: currentUser.email,
            lastName: currentUser.lastName
          },
          category: 'TicketView',
          value: JSON.stringify(defaultSelectedColumns)
        };
        if (actions?.savePersonalization && defaultPersonalization) {
          actions
            .savePersonalization({
              variables: { ...defaultPersonalization, name: createdView.id },
              input: { ...defaultPersonalization, name: createdView.id }
            })
            .finally(() => {
              // eslint-disable-next-line no-unused-expressions
              actions?.back();
              this.setState({ submitActionLoading: false });
            });
        } else {
          // eslint-disable-next-line no-unused-expressions
          actions?.back();
          this.setState({ submitActionLoading: false });
        }
      });
      // .finally(() => {
      //   // eslint-disable-next-line no-unused-expressions
      //   actions?.back();
      //   this.setState({ submitActionLoading: false });
      // });
    }
  };

  render() {
    const {
      personalization,
      viewCondition,
      view,
      errors,
      submitActionLoading,
      entityShare
    } = this.state;
    const { intl, actions, options, defaultSelectedColumns } = this.props;
    const providerValue = {
      ...actions,
      view: view,
      personalization: personalization,
      viewCondition: viewCondition,
      entityShare: entityShare,
      updateProperty: this.updateProperty,
      updateAutomationRule: this.updateFields,
      updateContext: this.updateContext,
      updateShareView: this.updateShareView
    };
    return (
      <TicketContext.Provider value={providerValue}>
        <Page
          variant="primary"
          title={`${
            this.props.view
              ? getTranslatedText(intl, 'ticket.View.header.edit')
              : getTranslatedText(intl, 'ticket.View.header.new')
          }`}
          primaryAction={
            <SaveCard
              handleSave={this.createOrUpdateViewType.bind(this)}
              actions={actions}
              loading={submitActionLoading}
              removeSecondaryBtnBg
            />
          }
          contentHeight="100px"
        >
          <ViewContainer
            defaultSelectedColumns={defaultSelectedColumns || []}
            view={view}
            personalization={personalization}
            errors={errors}
            entityShare={entityShare}
          />
        </Page>
      </TicketContext.Provider>
    );
  }
}

export default injectIntl(ViewSheet);
